/*global
    jQuery
*/
(function ($) {
    if ( $('form.delete-pet-form').length > 0 ) {
        var skipModal = true;
        var showHideDeletePetReasonField = function(e) {
            var $field = $(this),
                option = $(this).val(),
                $otherTextArea = $field.parents('ul').siblings('div.delete-reason-long');
            console.log('Option detected: ' + option);
            if ( option !== 'other' ) {
                if (option == 'adopted-p2p') {
                    console.log('selected adopted-p2p');
                    skipModal = false;
                } else {
                    skipModal = true;
                }
                $otherTextArea.find('textarea').val('');
                $otherTextArea.addClass('closed');
            } else {
                skipModal = true;
                $otherTextArea.removeClass('closed');
            }
        }

        var maybeRemoveErrorClass = function(e) {
            var $field = $(this),
                $wrapper = $field.parents('div.form-control');
            if ( $wrapper.hasClass('has-error') ) {
                $wrapper.removeClass('has-error');
            }
        }

        $('input[name="delete_reason"]').on('change', showHideDeletePetReasonField);
        $('form.delete-pet-form').find('input,textarea').on('click', maybeRemoveErrorClass);

        var openModal = function toggleModal() {
            var $target = $('.modal--suggestions');
        
            $target.toggleClass('is-open');
            $('body').toggleClass('no-scroll');
            /* $('.suggestions-trigger').css("display", "none");*/
        };
        
        var closeModal = function closeModal() {
            $('.modal--suggestions').toggleClass('is-open');
            $('body').toggleClass('no-scroll');
            /* $('.suggestions-trigger').css("display", "block");*/
        };

        var adopterClicked = function(e) {
            var $target = $(e.target);
            $('div.single-adopter.selected').removeClass('selected');
            $target.addClass('selected');
            enableModalSubmit();
        }

        var enableModalSubmit = function() {
            var adopterSelected = $('div.single-adopter.selected');
            if (typeof adopterSelected !== 'undefined' && adopterSelected.length > 0) {
                $('.modal--suggestions').find('button.modal__submit').attr('disabled', false);
            } else {
                $('.modal--suggestions').find('button.modal__submit').attr('disabled', true);
            }
        }

        var formSubmitHandler = function(e) {
            e.preventDefault();
            if (!skipModal) {
                openModal();
                return false;
            } else {
                $('form#delete-pet').submit();
            }
        }

        var submitModal = function(e) {
            e.preventDefault();
            var $target = $(e.target),
                application_id = $('div.single-adopter.selected').find('input[name="application-id"]').val();

            console.log('clicked');
            console.log('app_id: ' + application_id);
            if (typeof application_id !== 'undefined' && application_id !== '') {
                console.log('getting doc...');
                getDocument(application_id);
            } else {
                console.log('failed');
            }
        }


        var getDocument = function(application_id) {
            closeModal();
            console.log('modal should close');
            $.get('/api/contract/'+application_id, function(response) {
                if (typeof response !== 'undefined' && typeof response.status !== 'undefined' && response.status == 'success') {
                    console.log('should init contract');
                    initHelloSign(application_id, response.client_id, response.sign_url, response.redirect_url);
                } else if (typeof response !== 'undefined' && typeof response.status !== 'undefined' && response.status == 'already_signed') {
                    console.log('should init already signed');
                    $remodalInstance = $('div.already-signed-modal').remodal();
                    $(document).on('closed', '.remodal', function (e) {
                        if ( e.reason == undefined || e.reason == false || e.reason !== 'confirmation') {
                            $('body').toggleClass('no-scroll');
                            $('form#delete-pet').submit();
                        }
                    });
                    $('body').toggleClass('no-scroll');
                    $remodalInstance.open();
                }
            });
        };

        var initHelloSign = function(application_id, client_id, sign_url, redirect_url) {
            const client = new HelloSign({ clientId: client_id });
            $('body').toggleClass('no-scroll');
            client.open(sign_url, {
                allowCancel: true
            });

            client.on(HelloSign.events.SIGN, function () {
                $('body').toggleClass('no-scroll');
                document.location = redirect_url;
            });
        };
 
        $('div.single-adopter').on('click', adopterClicked); 
        $('form#delete-pet').find('input[type="submit"]').on('click', formSubmitHandler);
        $('button.modal__submit').on('click', submitModal);
        $('.suggestions-trigger').on('click', openModal);
        $('.modal__closer').on('click', closeModal);
    }
}(jQuery));
